<template>
  <div
    class="z-tag"
    :class="['z-tag--' + size, 'z-tag--' + effect, {'z-tag--disabled': disabled}]"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ZeroTag",
  props: {
    size: { type: String, default: "small" },
    effect: { type: String, default: "dark" },
    disabled: Boolean
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.z-tag {
  width: fit-content;
  padding: 0 24px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 12px;
  border-radius: $radius-button;
  & + .z-tag {
    margin-left: 10px;
  }
  &:hover {
    background-color: rgba($color: #fff, $alpha: 0.2);
  }
  &.is-circle {
    border-radius: 50%;
  }
  &--small {
    height: 32px;
  }
  &--mini {
    height: 28px;
  }
  &--smaller {
    height: 24px;
    padding: 0 12px;
    &.is-circle {
      width: 24px;
    }
  }
  &--smallest {
    height: 20px;
    padding: 0 10px;
    &.is-circle {
      width: 20px;
    }
  }
  &--dark {
    color: #fff;
    border: 1px solid #fff;
  }
  &--disabled {
    color: #fff;
    border: 1px dashed #fff;
    background-color: transparent !important;
    opacity: 0.2;
  }
}
</style>